/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class VersionService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation versionInfoGet
   */
  static readonly VersionInfoGetPath = '/Version/info';

  /**
   * Full assembly version information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionInfoGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VersionService.VersionInfoGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Full assembly version information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionInfoGet(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.versionInfoGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation versionGet
   */
  static readonly VersionGetPath = '/Version';

  /**
   * Service version number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VersionService.VersionGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Service version number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionGet(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.versionGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation versionTagGet
   */
  static readonly VersionTagGetPath = '/Version/tag';

  /**
   * System version - Version tag, repository mark.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionTagGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionTagGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VersionService.VersionTagGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * System version - Version tag, repository mark.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionTagGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionTagGet(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.versionTagGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation versionRevisionGet
   */
  static readonly VersionRevisionGetPath = '/Version/revision';

  /**
   * System version - build revision of the current build.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionRevisionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionRevisionGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VersionService.VersionRevisionGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * System version - build revision of the current build.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionRevisionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionRevisionGet(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.versionRevisionGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
